import {ApplicationSourceSection} from "../../utils/form/application_form_source";

export type AmplitudeLeadType = "single_lead" | "multi_lead";

export const getAmplitudeLeadType = (sourceSection: ApplicationSourceSection): AmplitudeLeadType => {
    if (sourceSection === ApplicationSourceSection.MULTILEAD || sourceSection === ApplicationSourceSection.VENDOR_MULTILEAD) {
        return "multi_lead";
    }

    return "single_lead";
};
import {ApplicationSourceSection} from "../../utils/form/application_form_source";

export type AmplitudeLeadType = "single_lead" | "multi_lead";

export const getAmplitudeLeadType = (sourceSection: ApplicationSourceSection): AmplitudeLeadType => {
    if (sourceSection === ApplicationSourceSection.MULTILEAD || sourceSection === ApplicationSourceSection.VENDOR_MULTILEAD) {
        return "multi_lead";
    }

    return "single_lead";
};
